import { render, staticRenderFns } from "./PaymentDataTable.vue?vue&type=template&id=022c62a2&scoped=true&"
import script from "./PaymentDataTable.vue?vue&type=script&lang=js&"
export * from "./PaymentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDataTable.vue?vue&type=style&index=0&id=022c62a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c62a2",
  null
  
)

export default component.exports